import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { useCollapsible } from '@hh.ru/magritte-common-use-collapsible';
import { Card } from '@hh.ru/magritte-ui-card';
import { ChevronDownOutlinedSize24 } from '@hh.ru/magritte-ui-icon/icon';

var styles = {"header":"magritte-header___N2Fys_2-5-70","title":"magritte-title___JwtRY_2-5-70","title-icon":"magritte-title-icon___QEIuf_2-5-70","titleIcon":"magritte-title-icon___QEIuf_2-5-70","title-icon_open":"magritte-title-icon_open___GkVV-_2-5-70","titleIconOpen":"magritte-title-icon_open___GkVV-_2-5-70","title-wrapper":"magritte-title-wrapper___BmAj-_2-5-70","titleWrapper":"magritte-title-wrapper___BmAj-_2-5-70"};

const Accordion = ({ title, onClick, padding = 16, children, expanded = false, stretched = true, controlled = false, borderRadius = 12, }) => {
    const [isLocalExpanded, setIsLocalExtended] = useState(expanded);
    const ref = useRef(null);
    useEffect(() => {
        setIsLocalExtended(expanded);
        // eslint-disable-next-line disable-autofix/react-hooks/exhaustive-deps
    }, [controlled]);
    const isExpanded = (controlled && expanded) || (!controlled && isLocalExpanded);
    const { collapsibleClasses } = useCollapsible(ref, isExpanded);
    const handleToggle = () => {
        if (!controlled) {
            setIsLocalExtended((prev) => !prev);
        }
        onClick?.();
    };
    const contentStyle = { padding: `0 ${padding}px ${padding}px ${padding}px` };
    const currentMaxHeightStyle = ref.current?.style.maxHeight;
    const maxHeightStyle = currentMaxHeightStyle
        ? { maxHeight: currentMaxHeightStyle }
        : { maxHeight: isExpanded ? 'none' : 0 };
    return (jsxs(Card, { borderWidth: "default", borderRadius: borderRadius, stretched: stretched, children: [jsx("div", { className: styles.titleWrapper, children: jsx(Card, { borderRadius: borderRadius, padding: padding, onClick: handleToggle, stretched: true, children: jsxs("div", { className: styles.header, children: [jsx("div", { "data-qa": "accordion-title", className: styles.title, children: title }), jsx("div", { "data-qa": "accordion-chevron", style: { marginLeft: `${padding}px` }, className: classNames(styles.titleIcon, {
                                    [styles.titleIconOpen]: isExpanded,
                                }), children: jsx(ChevronDownOutlinedSize24, { alignmentBaseline: "auto" }) })] }) }) }), jsx("div", { ref: ref, className: collapsibleClasses, "data-qa": "collapsible", style: maxHeightStyle, children: jsx("div", { "data-qa": "accordion-content", style: contentStyle, children: children }) })] }));
};

export { Accordion };
//# sourceMappingURL=Accordion.js.map
